import { Grid, Button, Typography, TextField } from "@material-ui/core";
import { PrimaryButton } from "../components-atoms";
import GeneralModal from "./GeneralModal";
import { useEffect, useState } from "react";


interface SubscriptionPayAsYouGoModalProps {
	classes: any;
	isVisible: boolean;
	isDisabled: boolean;
  defaultValue?: string | null;
	close: () => void;
	setPayAsYouGo: (payg: number) => void;
}

export function SubscriptionPayAsYouGoModal({ defaultValue, classes, isVisible, isDisabled, close, setPayAsYouGo }: SubscriptionPayAsYouGoModalProps): JSX.Element {
  const [payg, setPayg] = useState<string>(defaultValue?.toString() || "0.0");

  useEffect(() => {
    if(defaultValue){
      setPayg(defaultValue?.toString());
    }
  }, [defaultValue]);
  
	function isFloat(val: string) {
		var floatRegex = /^[0-9]+(\.)?[0-9]*$/;
		if (!floatRegex.test(val)) return false;
		if (isNaN(parseFloat(val))) return false;
		return true;
	}
	const hasInvalidPrice = !isFloat(payg) || parseFloat(payg) <= 0.0;

	return (
		<GeneralModal
			title="Pay as you go price"
			description="Update the pay as you go price for this subscription"
			modalWidth="560px"
			visible={isVisible}
			onClose={() => close()}
		>
			<GeneralModal.ContentArea>
				<Grid container style={{ marginTop: '16px' }}>
					<Grid item container spacing={2}>
						<Grid item xs={12}>
							<TextField
								fullWidth
								variant="outlined"
								margin="normal"
								id="PayAsYouGoPrice"
								placeholder="Pay as you go price"
								label="Pay as you go price"
								name="CategoryName"
								value={payg}
								onChange={v => setPayg(v.target.value)}
								error={hasInvalidPrice}
								disabled={isDisabled}
							/>
						</Grid>
					</Grid>
					{hasInvalidPrice && <Grid item xs={12}>
						<Typography variant="caption" color="error">
							Please enter a valid price.
						</Typography>
					</Grid>
					}
				</Grid>
			</GeneralModal.ContentArea>
			<GeneralModal.ButtonArea>
				<Button
					className={classes.cancelButton}
					onClick={() => close()}
					disabled={isDisabled}
				>
					<Typography
						variant="button"
						component="p"
						color="primary"
					>
						Cancel
					</Typography>
				</Button>
				<PrimaryButton
					title="Save"
					onClick={() => { if (!hasInvalidPrice) setPayAsYouGo(parseFloat(payg)); }}
					disabled={isDisabled || hasInvalidPrice}
					style={{ marginLeft: '8px' }}
				/>
			</GeneralModal.ButtonArea>
		</GeneralModal>
	);
}
